<template>
  <div class="wechatComplaint div-layout">
    <div v-if="!dialogDetailVisible&&!dialogAddVisible" class="wechatComplaint-main">
      <module-title title="投诉类型配置">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrView('add')"
          >
            添加投诉类型
          </el-button>
        </div>
      </module-title>
      <div class="wechatComplaint-main-contain">
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="投诉类型：" prop="typeName">
            <el-input
              v-model="searchForm.typeName"
              name="typeName"
              placeholder="请输入投诉类型"
              class="searchForm-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item style=" margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="投诉类型" prop="typeName" align="center" />
          <el-table-column label="类型名称数量" prop="subTypeNum" align="center" />
          <el-table-column label="投诉类型状态" prop="status" align="center">
            <template slot-scope="scope">
              {{ scope.row.status===1?'已开启':'已停用' }}
            </template>
          </el-table-column>
          <el-table-column label="添加时间" prop="createDate" align="center" width="100" />
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="viewCodeDetail(scope.row)"
              >
                查看
              </el-button>
              <el-button
                v-if="!scope.row.status"
                type="text"
                size="small"
                @click="handleUseEdit(scope.row)"
              >
                启用
              </el-button>
              <el-button
                v-if="scope.row.status"
                type="text"
                size="small"
                @click="handleUseEdit(scope.row)"
              >
                停用
              </el-button>
              <el-button
                v-if="!scope.row.status"
                type="text"
                size="small"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
              <el-button
                v-if="!scope.row.status"
                type="text"
                size="small"
                @click="handleUpdate(scope.row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog
      :title="'编辑投诉类型'"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="投诉类型：" prop="typeName">
          <el-input v-model="ruleForm.typeName" maxlength="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <Detail v-if="dialogDetailVisible" :detail-props="detailProps" :update-row="updateRow" @back="backAdd('detail')" />
    <Add v-if="dialogAddVisible" :detail-props="detailProps" :update-row="updateRow" :handle-type="handleType" @back="backAdd('add')" />
  </div>
</template>

<script>

import {
  get_complain_queryTypePageList,
  type_complain_enable,
  type_complain_delete,
  deleteRow,
  updateComplaintName
} from '@/api/systemMaintenance/devicManage/wechatComplaint';
import Detail from './detail.vue';
import Add from './add.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'WechatComplaint',
  components: { Detail, Add },
  data() {
    return {
      ruleForm: {
        typeName: ''
      },
      rules: {
        typeName: [
          { required: true, message: '请输入投诉类型', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      ajaxLoading: false,
      dialogDetailVisible: false,
      dialogAddVisible: false,
      handleType: 'add',
      updateRow: {},
      detailProps: {},
      // 搜索表单
      searchForm: {
        typeName: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dateTime: '',
      dataList: [],
      terminalList: [],
      listLoading: false, // 表格刷新loading
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天
        }
      }// 时间控件限制
    };
  },
  mounted() {
    this.fetchdataList();
  },
  computed: {
    ...mapGetters(['userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            typeName: this.ruleForm.typeName,
            updateUserCode: this.userCode,
            sort: 0,
            parentId: 0
          };
          updateComplaintName(this.updateRow.id, data).then(res => {
            this.fetchdataList();
            this.dialogVisible = false;
            this.$notify.success({
              title: 'Success',
              message: `操作成功`,
              showClose: false,
              duration: 2000
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchdataList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchdataList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchdataList();
    },
    backAdd(val) {
      val === 'detail' ? this.dialogDetailVisible = false : this.dialogAddVisible = false;
      this.fetchdataList();
    },
    handleSearchReset() {
      this.searchForm = {
        typeName: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    // 查看
    viewCodeDetail(row) {
      this.updateRow = row;
      this.detailProps.id = row.id;
      this.dialogDetailVisible = true;
    },
    opAddOrView() {
      this.handleType = 'add';
      this.dialogAddVisible = true;
      this.dialogDetailVisible = false;
    },
    handleUpdate(row) {
      this.updateRow = row;
      this.ruleForm.typeName = row.typeName;
      this.dialogVisible = true;
    },
    // 启用停用
    handleUseEdit(row) {
      this.$confirm(
        `确定要${row.status ? '停用' : '启用'}该投诉类型么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          if (row.status) {
            return type_complain_delete(row.id);
          } else {
            return type_complain_enable(row.id);
          }
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${row.status ? '停用' : '启用'}成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchdataList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 删除
    handleDelete(row) {
      this.$confirm(
        `您确认删除该投诉类型吗?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          return deleteRow(row.id);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `操作成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchdataList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取应用列表
    fetchdataList() {
      this.listLoading = true;
      var option = {
        ...this.searchForm
      };
      delete option.total;
      get_complain_queryTypePageList(option)
        .then(result => {
          if (result.data && result.data.list && result.data.list.length) {
            this.dataList = result.data.list;
            this.searchForm.total = result.data.total;
          } else {
            this.dataList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.wechatComplaint {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
  .searchForm-form-input{
     width: 400px;
  }
}
</style>

